import { ref } from "vue";

export const messageAlertSelectProductHappyEmpty = {
    option: [],
    type: "",
    message: ""
}

export interface messageAlertSelectProductHappyEmpty {
    option: any[]
    type: string,
    message: string
}
export const messageAlertSelectProductHappy = ref<messageAlertSelectProductHappyEmpty>(messageAlertSelectProductHappyEmpty)